import { formatDate, formatDateCMProgressBar } from '/@/utils';

/**
 * Strong-wind threshold (km/h) used to flag days at risk of lodging/stem-breakage
 * ("vuelco y quebrado") and to gate the drift application-risk warning.
 * Placeholder default pending definition by Product — change here to update every
 * chart/reference/notification that reads it.
 */
export const STRONG_WIND_THRESHOLD_KMH = 39;

/**
 * Rounds a value, falling back to `undefined` (rather than NaN) when the value is
 * missing — forecast days don't always carry every otherData field.
 */
const roundOrUndefined = (value) => {
    const numericValue = Number(value);
    return value === null || value === undefined || Number.isNaN(numericValue) ? undefined : Math.round(numericValue);
};

/**
 *
 * @param {import('hooks/weather').HistoricalWeatherQuery | undefined} [historicalWeather]
 * @param {'temperature' | 'rain' | 'wind' | 'humidity'} type
 * @param {*} quantity
 * @param {*} page
 * @param {*} pages
 * @returns
 */
export const transformData = (historicalWeather, type, quantity, page, pages) => {
    const quantityData = quantity ? quantity : ((historicalWeather && historicalWeather.results) || []).length;
    const formatData = ((historicalWeather && historicalWeather.results) || []).map((dh) => {
        const date = new Date(dh.date);
        const dayMonthDate = formatDate(date, { dayMonthOnly: true });
        const fullDate = formatDate(date);
        return {
            data: dayMonthDate,
            temperatureMax: Math.round(dh.otherData.TemperatureLocalDayMax),
            temperatureMin: Math.round(dh.otherData.TemperatureLocalDayMin),
            temperature: Math.round(dh.otherData.TemperatureLocalDayAvg),
            wind: Math.round(dh.otherData.WindSpeedLocalDayAvg),
            windMax: roundOrUndefined(dh.otherData.WindSpeedLocalDayMax),
            windMin: roundOrUndefined(dh.otherData.WindSpeedLocalDayMin),
            rain: Number(dh.otherData.PrecipAmountLocalDayAccum).toFixed(1),
            humidity: Math.round(dh.otherData.RelativeHumidityLocalDayAvg),
            none: Math.round(dh.gduAccum),
            precipitations: dh.precipAccum,
            textTooltip:
                type === 'none'
                    ? `${formatDateCMProgressBar(fullDate)} | GDU ${Math.round(dh.gduAccum)}`
                    : formatDateCMProgressBar(fullDate),
        };
    });

    if (page !== undefined && pages !== undefined) {
        return formatData
            .reverse()
            .slice(
                Math.max(formatData.length - (pages - page + 1) * quantity, 0),
                formatData.length - (pages - page) * quantity
            );
    }
    return formatData.slice(0, quantityData).reverse();
};
